module.exports = __webpack_public_path__ + "assets/images/M.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/M.png
// module id = 1418
// module chunks = 1